import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';
import { DashboardOrder } from '../../types';

interface NewOrdersFeedProps {
  orders: DashboardOrder[];
}

function NewOrdersFeed({ orders }: NewOrdersFeedProps) {
  const { t, lang } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="partner-orders-feed">
      <div className="partner-orders-header">
        <h3>{t('dashboard.orders.title')} ({orders.length})</h3>
        <button className="partner-orders-see-all">
          {t('dashboard.orders.seeAll')} &rarr;
        </button>
      </div>

      {orders.length === 0 ? (
        <div className="partner-orders-empty">
          {t('dashboard.orders.empty')}
        </div>
      ) : (
        orders.map((order) => (
          <div key={order.orderId} className="partner-order-card">
            <div className="partner-order-card-top">
              <div className="partner-order-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="3" width="16" height="14" rx="2" />
                  <path d="M6 7h8" />
                  <path d="M6 10h8" />
                  <path d="M6 13h4" />
                </svg>
              </div>
              <span className="partner-order-title">{order.type}</span>
            </div>

            <div className="partner-order-details">
              <div>
                <span className="partner-order-detail-label">{t('dashboard.orders.service')}: </span>
                {order.serviceName}
              </div>
              <div>
                <span className="partner-order-detail-label">{t('dashboard.orders.carModel')}: </span>
                {order.carModel}
              </div>
              {order.pickupTime && (
                <div>
                  <span className="partner-order-detail-label">{t('dashboard.orders.pickupTime')}: </span>
                  {order.pickupTime}
                </div>
              )}
              {order.pickupLocation && (
                <div>
                  <span className="partner-order-detail-label">{t('dashboard.orders.pickupLocation')}: </span>
                  {order.pickupLocation}
                </div>
              )}
            </div>

            {/* Spec 048 removed garage accept/reject — the only sensible card action
                is opening the order (the journey is admin-orchestrated). */}
            <div className="partner-order-actions">
              <button
                className="partner-order-accept"
                onClick={() => navigate(`/orders/${order.orderId}`)}
              >
                {lang === 'ar' ? 'عرض الطلب' : 'View order'}
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default NewOrdersFeed;
